import { create } from "zustand";

export const QUERY_PARAMS_KEYS = {
  DANH_SACH_KIEM_KHO: "danh-sach-kiem-kho",
  DANH_SACH_KIEM_KHO_CUOI_THANG: "danh-sach-kiem-kho-cuoi-thang",
  DANH_SACH_DIEU_CHINH_LUONG_TON_KHO: "danh-sach-dieu-chinh-luong-ton-kho",
  DANH_SACH_DINH_MUC_TON_KHO: "danh-sach-dinh-muc-ton-kho",

  DANH_SACH_TRA_HANG: "danh-sach-tra-hang",
  DANH_SACH_HUY_HANG: "danh-sach-huy-hang",

  DANH_SACH_PHIEU_XUAT_BIA: "danh-sach-phieu-xuat-bia",
  DANH_SACH_NHAP_HANG_KTT: "danh-sach-nhap-hang-ktt",
  IN_PHIEU_NHAP_KTT: "in-phieu-nhap-ktt",

  DANH_SACH_NHAP_HANG_KCN: "danh-sach-nhap-hang-kcn",
  IN_PHIEU_NHAP_KCN: "in-phieu-nhap-kcn",
  DANH_SACH_NHAP_MUA_NGOAI_KCN: "danh-sach-nhap-mua-ngoai-kcn",

  DANH_SACH_NGUYEN_VAT_LIEU: "danh-sach-nguyen-vat-lieu",
  DANH_SACH_NVL_SO_CHE: "danh-sach-nvl-so-che",
  DANH_SACH_BAN_THANH_PHAM: "danh-sach-ban-thanh-pham",
  DANH_SACH_NHAP_NVL_SO_CHE: "danh-sach-nhap-nvl-so-che",

  DANH_SACH_HANG_HOA: "danh-sach-hang-hoa",
  DANH_SACH_DE_XUAT_HANG_HOA: "danh-sach-de-xuat-hang-hoa",
};

export const useSavedQueryParams = create((set) => ({
  params: {},
  setQuery: (key, _params) =>
    set((state) => ({
      params: {
        ...state.params,
        [key]: {
          query: _params,
          table: { page: 1, limit: state?.params?.[key]?.table?.limit || 10 },
        },
      },
    })),
  setTable: (key, _params) =>
    set((state) => ({
      params: {
        ...state.params,
        [key]: {
          query: state?.params?.[key]?.query,
          table: _params,
        },
      },
    })),
}));
